import { Button } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import { useApproveCancellationBatch } from './useApproveCancellationBatch'
import { confirmPopup } from '@/components/popup'

interface BatchApproveButtonProps {
  selectedIds: string[]
  onSuccess: () => void
}

export function BatchApproveButton({ selectedIds, onSuccess }: BatchApproveButtonProps) {
  const { t } = useTranslation()
  const { approveBatch, isApproving } = useApproveCancellationBatch()

  const handleClick = () => {
    confirmPopup({
      title: t('common.modals.batchApproveTitle'),
      content: (
        <>
          <p>{t('common.modals.batchApproveMessage', { count: selectedIds.length })}</p>
          <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
            {t('common.modals.batchApproveWarning')}
          </p>
        </>
      ),
      okText: t('common.buttons.confirm'),
      cancelText: t('common.buttons.cancel'),
      okButtonProps: { 'data-testid': 'batch-approve-confirm-btn' },
      cancelButtonProps: { 'data-testid': 'batch-approve-cancel-btn' },
      // Returning the promise keeps the dialog's OK button loading until the server answered, and
      // the selection is cleared only after a success. It used to be cleared at once: the button
      // vanished while the request was still running and the same rows could be approved again.
      onOk: async () => {
        if (await approveBatch(selectedIds)) {
          onSuccess()
        }
      },
    })
  }

  if (selectedIds.length === 0) return null

  return (
    <Button
      data-testid="cancellation-list-batch-approve-btn"
      type="primary"
      icon={<CheckOutlined />}
      loading={isApproving}
      onClick={handleClick}
    >
      {t('common.buttons.approveSelected', { count: selectedIds.length })}
    </Button>
  )
}
